import {
    LocalLoginRequestData,
    LoginRequestData,
    UserData,
} from "../actions/authentificationActions";
import { IActiveDirectorySettings } from "../models/activeDirectorySettings";
import { IResetPasswordRequest } from "../models/auth";

export function login(data: LoginRequestData): Promise<UserData> {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    };

    return fetch(`/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if (user.token) {
                sessionStorage.setItem("user", JSON.stringify(user));
                sessionStorage.setItem("loggedIn", JSON.stringify(true));
            }

            return user;
        });
}

export function getActiveDirectorySettings(): Promise<IActiveDirectorySettings> {
    return fetch(`/users/activeDirectorySettings`).then(res => res.json());
}

export function localLogin(data: LocalLoginRequestData): Promise<UserData> {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams({
            username: data.username,
            password: data.password,
        }),
    };

    return fetch(`/users/LocalAuthenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if (user.token) {
                sessionStorage.setItem("user", JSON.stringify(user));
                sessionStorage.setItem("loggedIn", JSON.stringify(true));
            }

            return user;
        });
}

export async function forgotPassword(email: string): Promise<void> {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    };

    const res = await fetch(`/users/forgotPassword`, requestOptions);
    if (!res.ok) await handleErrorResponse(res, "Unable to send email with instructions.");
}

export async function resetPassword(resetRequest: IResetPasswordRequest): Promise<void> {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(resetRequest),
    };

    const res = await fetch(`/users/resetPassword`, requestOptions);
    if (!res.ok) await handleErrorResponse(res, "Unable to reset password.");
}

export function logout() {
    sessionStorage.removeItem("user");
    sessionStorage.setItem("loggedIn", JSON.stringify(false));
}

export async function isLocalLoginEnabled(): Promise<boolean> {
    return fetch(`/users/isLocalLoginEnabled`).then(res =>
        res.text().then(text => text === "true")
    );
}

function handleResponse(response: Response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logout();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data || response.ok;
    });
}

async function handleErrorResponse(res: Response, defaultMessage?: string): Promise<void> {
    // Check if response is a json object, if so, try to parse it an read the message property, otherwise if it is text just return it
    if (res.headers.get("content-type")?.includes("application/json")) {
        const json = await res.json();
        throw new Error(json.message ?? defaultMessage);
    } else if (res.headers.get("content-type")?.includes("text/plain")) {
        throw new Error((await res.text()) ?? defaultMessage);
    } else {
        throw new Error(defaultMessage);
    }
}

const exportedObject = {
    login,
    localLogin,
    logout,
};

export default exportedObject;
